import { render } from "./ServicesAccelere.vue?vue&type=template&id=87ca27c8&scoped=true"
import script from "./ServicesAccelere.vue?vue&type=script&lang=js"
export * from "./ServicesAccelere.vue?vue&type=script&lang=js"

import "./ServicesAccelere.vue?vue&type=style&index=0&id=87ca27c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ca27c8"]])

export default __exports__